var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ED3E47",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04846 4.1665C7.29104 4.1665 7.48769 4.35562 7.48769 4.58892V5.44101C7.87731 5.43375 8.31403 5.43375 8.80541 5.43375H11.148C11.6394 5.43375 12.0761 5.43375 12.4657 5.44101V4.58892C12.4657 4.35562 12.6624 4.1665 12.905 4.1665C13.1475 4.1665 13.3442 4.35562 13.3442 4.58892V5.47838C14.1871 5.5433 14.7405 5.70261 15.1471 6.0936C15.5536 6.48458 15.7193 7.01677 15.7868 7.82742L15.8333 8.24984H4.70595H4.16663V7.82742C4.23413 7.01677 4.39978 6.48458 4.80634 6.0936C5.2129 5.70261 5.76628 5.5433 6.60922 5.47838V4.58892C6.60922 4.35562 6.80587 4.1665 7.04846 4.1665Z",
    fill: "#ED3E47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.8333 11.1667V10C15.8333 9.51061 15.8314 8.63807 15.8239 8.25H4.1723C4.16477 8.63807 4.16667 9.51061 4.16667 10V11.1667C4.16667 13.3666 4.16667 14.4665 4.85009 15.15C5.53351 15.8334 6.63345 15.8334 8.83334 15.8334H11.1667C13.3666 15.8334 14.4665 15.8334 15.1499 15.15C15.8333 14.4665 15.8333 13.3666 15.8333 11.1667Z",
    fill: "#ED3E47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3939 12.0676C12.3038 11.9775 12.1577 11.9775 12.0676 12.0676C11.9775 12.1577 11.9775 12.3038 12.0676 12.3939L12.6736 13L12.0676 13.6061C11.9775 13.6962 11.9775 13.8423 12.0676 13.9324C12.1577 14.0225 12.3038 14.0225 12.394 13.9324L13 13.3264L13.606 13.9324C13.6962 14.0225 13.8423 14.0225 13.9324 13.9324C14.0225 13.8423 14.0225 13.6962 13.9324 13.606L13.3264 13L13.9324 12.394C14.0225 12.3038 14.0225 12.1577 13.9324 12.0676C13.8423 11.9775 13.6962 11.9775 13.6061 12.0676L13 12.6736L12.3939 12.0676Z",
    fill: "#ED3E47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoff);
export default __webpack_public_path__ + "static/media/timeoff.4b86b059378c7b89660fadd319ee519a.svg";
export { ForwardRef as ReactComponent };